// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__9dwkW","noInteraction":"EventWrapper_noInteraction__1ZZW4","pointerPassthrough":"EventWrapper_pointerPassthrough__1hZ8c"};